module.exports = __webpack_public_path__ + "img/jiaoyi.c155e55d.jpg";